import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function StickyMobileCTA() {
  const [visible, setVisible] = React.useState(false);
  React.useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 620);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-197" data-mp="w4m102mr7o10">
      {visible && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.24,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-line bg-white/95 px-4 py-3 backdrop-blur-xl sm:hidden" data-id="element-198" data-mp="111m5wa7vakqj">
          <CTAButton label="Abrir cuenta" location="sticky_mobile" size="md" className="w-full" data-id="element-199" data-mp="dbrwk2mrbeb1" />
        </motion.div>}
    </AnimatePresence>;
}